"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function getDimensionObject(node) {
    const rect = node.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: 'x' in rect ? rect.x : rect.top,
        left: 'y' in rect ? rect.y : rect.left,
        x: 'x' in rect ? rect.x : rect.left,
        y: 'y' in rect ? rect.y : rect.top,
        right: rect.right,
        bottom: rect.bottom,
    };
}
function useDimensions({ liveMeasure = true } = {}) {
    const [dimensions, setDimensions] = (0, react_1.useState)({
        width: null,
        height: null,
        top: null,
        left: null,
        x: null,
        y: null,
        right: null,
        bottom: null,
    });
    const [node, setNode] = (0, react_1.useState)(null);
    const ref = (0, react_1.useCallback)(newNode => setNode(newNode), []);
    (0, react_1.useLayoutEffect)(() => {
        if (!node) {
            return;
        }
        const measure = () => window.requestAnimationFrame(() => setDimensions(getDimensionObject(node)));
        measure();
        if (liveMeasure) {
            if ('ResizeObserver' in window) {
                const resizeObserver = new window['ResizeObserver'](measure);
                resizeObserver.observe(node);
                return () => {
                    resizeObserver.disconnect();
                };
            }
            else {
                window.addEventListener('resize', measure);
                window.addEventListener('scroll', measure);
                return () => {
                    window.removeEventListener('resize', measure);
                    window.removeEventListener('scroll', measure);
                };
            }
        }
    }, [node, liveMeasure]);
    return [ref, dimensions, node];
}
exports.default = useDimensions;
